$(document).ready(function () {
  $(document).on('click', '.clients-momentum-planning-first-impressions-component .first-impressions-section-options .radio-buttons__option', function () {
    const component = $(this).closest('.clients-momentum-planning-first-impressions-component'); // Update yes-no radio button values back to section
    const id = component.attr('momentum_first_impressions_section_id'); // Id of the section
    const property = $(this).attr('attr'); // Which radio is getting clicked
    const value = $(this).attr('value'); // Value of the radio button
    updateFirstImpressionsSection(id, property, value);
  });

  $(document).on('change', '.first-impressions-section-date-picker input', function () {
    const component = $(this).closest('.clients-momentum-planning-first-impressions-component'); // Assuming component has relevant section data
    const id = component.attr('momentum_first_impressions_section_id'); // Get the section ID
    const property = $(this).attr('name');
    const value = $(this).val(); // Get the new date value

    updateFirstImpressionsSection(id, property, value); // Call the update function
  });

  function updateFirstImpressionsSection(id, property, value) {
    $.post('/components/clients/momentum_sections/first_impressions', {
      id: id,
      property: property,
      value: value
    }).done(function (data) {

      if (data.success) {
        window.reloadConfirmationDayReadinessAssessmentComponent();
        window.reloadMomentumSectionPlanningTab(data.section_completion_percentage, 'first_impressions');
        window.reloadClientTaskBinComponents();
      }
    });
  }
});
